// Centralized contact info for JR Assistência Auto 24h
export const CONTACTS = {
  phones: [
    { label: "(11) 95486-1804", raw: "5511954861804" },
  ],
  whatsappMessage: "Olá! Preciso de assistência auto 24h. Pode me ajudar?",
};

export const waLink = (raw, msg = CONTACTS.whatsappMessage) =>
  `https://wa.me/${raw}?text=${encodeURIComponent(msg)}`;

export const telLink = (raw) => `tel:+${raw}`;

export const LOGOS = {
  main: "https://customer-assets.emergentagent.com/job_auto-socorro-rapido/artifacts/tjah8c39_Captura_de_Tela_2026-06-11_a%CC%80s_13.06.48-removebg-preview.png",
  banner:
    "https://customer-assets.emergentagent.com/job_auto-socorro-rapido/artifacts/omrwm8od_WhatsApp%20Image%202026-06-10%20at%2020.08.38.jpeg",
};
